import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

export default class BeamSetting extends Dialog {
    targetBeam: marietta.webcad.item.Beam;

    initDone: boolean = false; // 初期化完了

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ターゲットのお部屋
      this.targetBeam = marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Beam;
      this.initDone = false;

      // ダイアログのコンテンツ生成
      const id = 'beamSettingDialog';
      let title = '梁高さ設定';

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Beam Height Setting'; break;
        default: title = '梁高さ設定'; break;
      }

      let contents = '<div class="dialogBeamSetting">\n';
      contents += '<table>\n';
      contents += '<tbody>\n';

      // 数値設定
      contents += '<table id="beamSettingGroup">\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<th>\n<label for="beamHeight"><span class="jp">高さ</span><span class="en">Height</span></label></th>\n';
      contents += '<td>\n<input type="number" min="10" max="1000" name="beamHeight" id="beamHeight">\n<td>mm</td>\n</td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';

      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>';

      let footer = '<button id="btnDoneBeamSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="btnCancelBeamSetting"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

      this.createDialog(id, title, contents, footer);
      // イベント設定
      (<HTMLButtonElement>document.getElementById('btnDoneBeamSetting')).addEventListener('click', this.updateBeam);
      this.setInputFilter([document.getElementById('btnDoneBeamSetting')], (value) => /^-?\d*[.,]?\d*$/.test(value));
      // イベント設定
      (<HTMLButtonElement>document.getElementById('btnCancelBeamSetting')).addEventListener('click', this.close);
      (<HTMLInputElement>document.getElementById('beamHeight')).value = this.targetBeam.itemInfo.height.toString();
    }

    /**
     * 建具設定の反映
     */
     updateBeam = () => {
       // 入力チェック
       const value:number = parseFloat((<HTMLInputElement>document.getElementById('beamHeight')).value);
       if (value === null || Number.isNaN(value)) {
         marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('BEAMSETTING_NO_BEAMHEIGHT'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
         return;
       }
       if (value < 10 || value > 1000) {
         marietta.webcad.WebCADGlobal.showAlert((marietta.webcad.WebCADGlobal.language === 'jp') ? '高さには10mm以上、1000mm以下の数値を入力してください。' : 'Please input from 10mm to 1000mm for the height.',
           marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
         return;
       }
       this.targetBeam.itemInfo.height = value;

       //見積一覧を更新する
       marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();

       // ダイアログを閉じる
       this.close();
     }

      setInputFilter= (textbox, inputFilter) => {
        ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach((event) => {
          for (let i = 0; i < textbox.length; i += 1) {
            (<HTMLInputElement>textbox[i]).addEventListener(event, function () {
              if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
                // eslint-disable-next-line no-prototype-builtins
              } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
              }
            });
          }
        });
      }
}
